import Button from 'components/button';
import Modal from '..';
import styles from './styles.module.scss';
import Select from 'components/select';
import { SingleValue } from 'react-select';
import SelectOptions from 'models/Profile/SelectOptions';
import { useMenu } from 'context/MenuContext';
import { useState } from 'react';
import formatIdentifier from 'utils/formatIdentifier';
import { t } from 'i18next';
import CurrentCompany from 'models/Profile/CurrentCompany';
import { updateCookieCurrentProduct } from 'utils/productCookies';
import { getPreferredLanguage } from 'utils/preferredLanguage';

type ProductIdentifier = {
  applicationName: string;
  applicationNoun: string;
  callbackUrl: string;
  closeModal : () => void;
}

function ProductIdentifierModal(props : ProductIdentifier) : JSX.Element {
  const
    {
      companies,
      updateCurrentCompany
    } = useMenu();

  const preferredLanguage = getPreferredLanguage();
  const [company, setCompany] = useState({} as CurrentCompany);

  const onChange = (newValue : SingleValue<SelectOptions>) : void => {
    const value = newValue?.value;
    if(value === undefined)
      return;

    const labelValues = newValue?.label.split('\n') || [];
    const hasGroupName = labelValues.length === 2 ? 0 : 1;

    const company : CurrentCompany = {
      name : labelValues[hasGroupName],
      identifier : value,
      companyId: newValue?.companyId || []
    };

    setCompany(company);
  };

  const onClick = () : void => {
    updateCurrentCompany(company);
    updateCookieCurrentProduct(props.applicationNoun);

    window.location.href = props.callbackUrl;
    props.closeModal();
  };

  const getOptions = () : SelectOptions[] => {
    const productName = props.applicationName;
    const companiesWithProduct = companies.filter(x => x.products.some(x => x.product == productName));

    return companiesWithProduct.map<SelectOptions>(x => {
      const selectOption : SelectOptions = {
        value : x.identifier,
        label: x.name + '\n' + formatIdentifier(x.identifier, preferredLanguage),
        companyId: x.companyId
      };

      if(!x.groups)
        return selectOption;

      const group = x.groups.filter(x => x.productName === productName);
      if(!group || group.length == 0)
        return selectOption;

      return {...selectOption, label: group[0].groupName + '\n' + selectOption.label };
    });
  };

  return (
    <Modal
      title={`${t('biobar.modal.identifier.title')} ${props.applicationNoun}`}
      closeModal={props.closeModal}
    >
      <div id={styles['biobar-message']}>
        <p>
          {t('biobar.modal.identifier.p.first-line')}<br />
          {t('biobar.modal.identifier.p.second-line')}
        </p>
      </div>
      <div>
        <Select
          classNamePrefix='modal-select'
          placeholder={t('biobar.modal.identifier.select.placeholder')}
          onChange={onChange}
          options={getOptions()}
        />
      </div>
      <div id={styles['biobar-footer']}>
        <Button
          outline={true}
          onClick={props.closeModal}
          text={t('biobar.button.cancel')}/>
        <Button
          onClick={onClick}
          text={t('biobar.button.continue')}/>
      </div>
    </Modal>
  );
}

export default ProductIdentifierModal;